import * as API from "utils/api";
import HTTPStatus from "http-status";
import { push } from "react-router-redux";

const destroyAdRequest = () => ({
  type: "DESTROY_AD_REQUEST",
  auth: true,
})

const updateAdRequest = () => ({
  type: "UPDATE_AD_REQUEST",
  auth: true,
})

const createAdRequest = () => ({
  type: "CREATE_AD_REQUEST",
  auth: true,
})

const getAdsSuccess = ads => ({
  type: "GET_ADS_SUCCESS",
  ads
});

const getAdsBySearchSuccess = ads => ({
  type: "GET_ADS_BY_SEARCH_SUCCESS",
  ads
})

const getAdSuccess = ad => ({
  type: "GET_AD_SUCCESS",
  ad
});

const getAdByCountySuccess = ad => ({
  type: "GET_AD_BY_COUNTY_SUCCESS",
  ad
})

const getAdByCountyFailure = () => ({
  type: "GET_AD_BY_COUNTY_FAILURE",
})

const createAdSuccess = ad => ({
  type: "CREATE_AD_SUCCESS",
  ad
});

const destroyAdSuccess = id => ({
  type: "DESTROY_AD_SUCCESS",
  id
});

const updateAdSuccess = ad => ({
  type: "UPDATE_AD_SUCCESS",
  ad
});

const getAdsFailure = () => ({
  type: "GET_ADS_FAILURE"
});

const getAdFailure = () => ({
  type: "GET_AD_FAILURE"
});

const createAdFailure = () => ({
  type: "CREATE_AD_FAILURE"
});

export const getAds = (pageNumber) => async dispatch => {
  const response = await API.get(`/ads?pageNumber=${pageNumber}`);
  switch (response.status) {
    case HTTPStatus.OK:
      const ads = await response.json();
      dispatch(getAdsSuccess(ads));
      break;
    default:
      dispatch(getAdsFailure());
  }
};

export const getAdsBySearch = (searchValue) => async dispatch => {
  const response = await API.get(`/ads?title=${searchValue}`)
  switch (response.status) {
    case HTTPStatus.OK:
      const ads = await response.json();
      dispatch(getAdsBySearchSuccess(ads))
      break
    default:
      dispatch(getAdsFailure());
  }
}

export const getAd = id => async dispatch => {
  const response = await API.get(`/ads/${id}`);

  switch (response.status) {
    case HTTPStatus.OK:
      const ad = await response.json();
      dispatch(getAdSuccess(ad));
      break;
    default:
      dispatch(getAdFailure());
      break;
  }
};

export const getAdByCounty = countyId => async dispatch => {
  const response = await API.get(`/counties/${countyId}/ads`)
  switch (response.status) {
    case HTTPStatus.OK:
      const ad = await response.json()
      dispatch(getAdByCountySuccess(ad))
      break;
    default:
      dispatch(getAdByCountyFailure())
      break;
  }
}

export const createAd = ad => async dispatch => {
  dispatch(createAdRequest())
  const config = { body: JSON.stringify({ ...ad }) };
  const response = await API.post("/ads", config);

  switch (response.status) {
    case HTTPStatus.CREATED:
      const createdAd = await response.json();
      dispatch(createAdSuccess(createdAd));
      dispatch(push("/admin/ads"));
      break;
    default:
      dispatch(createAdFailure());
      break;
  }
};

export const destroyAd = id => dispatch => {
  dispatch(destroyAdRequest())
  dispatch(destroyAdSuccess(id));
  API.destroy(`/ads/${id}`);
}

export const updateAd = (id, ad) => async dispatch => {
  dispatch(updateAdRequest())
  const config = { body: JSON.stringify({ ...ad })};
  const response = await API.patch(`/ads/${id}`, config);
  const data = await response.json();

  dispatch(updateAdSuccess(data));
  dispatch(push("/admin/ads"));
}


// WEBPACK FOOTER //
// src/data/ads/actions.js